import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90vh] md:min-h-screen flex items-center justify-center bg-gradient-to-b from-cream to-[#F0EFEA] py-16 px-4 overflow-hidden" data-id="element-64">
      {/* Subtle background decoration */}
      <div className="absolute inset-0 opacity-5 pointer-events-none flex justify-center items-center" data-id="element-65">
        <div className="w-[800px] h-[800px] rounded-full border-[40px] border-orange blur-3xl" data-id="element-66"></div>
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-68">
          <div className="inline-block mb-4 px-4 py-1.5 bg-crimson/10 border border-crimson/20 rounded-full" data-id="element-69">
            <span className="text-crimson font-bold text-sm tracking-wider uppercase" data-id="element-70">
              Atención: Si sufres de ciática
            </span>
          </div>

          <h1 className="font-heading font-black text-[2.5rem] leading-[1.15] md:text-[3.5rem] text-charcoal mb-6 md:mb-8" data-id="element-71">
            ¿El dolor de ciática te está robando tu capacidad de trabajar y
            ganar dinero?
          </h1>

          <h2 className="font-heading font-bold text-[1.5rem] leading-[1.4] md:text-[2rem] text-warm-gray mb-10 md:mb-12" data-id="element-72">
            El Protocolo SOS de 14 días para desactivar la agonía lumbar y
            volver a caminar sin dolor —{' '}
            <span className="text-navy underline decoration-orange decoration-4 underline-offset-4" data-id="element-73">
              Sin citas médicas costosas ni cirugías riesgosas.
            </span>
          </h2>

          <CTAButton href="#pricing-section" data-id="element-74" />
        </motion.div>
      </div>
    </section>;
}